import { defineStore } from 'pinia'
import { createI18n, I18n, I18nMode, I18nScope } from 'vue-i18n'

export const useI18nStore = defineStore({
  id: 'i18n',
  state: () => ({
    loaded: false,
    i18n: createI18n({
      legacy: false,
      fallbackLocale: 'es',
      globalInjection: true,
      missingWarn: false,
      fallbackWarn: false
    })
  }),
  getters: {
    getI18n(): any {
      return this.i18n
    }
  },
  actions: {
    loading(value: boolean) {
      this.loaded = value
    },
    setLocaleMessages(locale: string, message: Record<string, string>) {
      this.i18n.global.setLocaleMessage(locale, message)
    },
    setLocale(locale: string) {
      this.i18n.global.locale = locale
    },
    getLoaded() {
      return this.loaded
    }
  }
})
